import { Component, OnInit } from '@angular/core';

import testTheme from '../../theme.json';
import { LogoService } from 'src/app/services/logo.service';
import { ThemeService } from 'src/app/services/theme.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
})
export class BaseComponent {
  constructor(
    private logoService: LogoService,
    private themeService: ThemeService
  ) {}
  id!: string;
  checked: boolean = false;
  idCheckati: string[] = [];
  isPhone: boolean = false;
  logo!: string;
  changeColor: boolean = false;
  prod = environment.production;
  showDemo = environment.demo;

  ngOnInit(): void {
    this.logoService.getLogo().subscribe((logo) => {
      this.logo = logo;
    });
  }
  check: any = [];

  log() {
    console.log('Button clicked');
  }

  mapCheck: any = [
    {
      id: 1,
      nome: 'Risposta 1 (una riga)',
    },
    {
      id: 2,
      nome: 'Risposta 2 (una riga)',
    },
    {
      id: 3,
      nome: 'Risposta 3 Lorem ipsum quis ipsum dictum pellentesque (su due righe)',
    },
    {
      id: 4,
      nome: 'Risposta 4 (una riga)',
    },
    {
      id: 5,
      nome: 'Risposta 5 (una riga)',
    },
  ];

  selectedColor: string = '';

  onColorChange(event: any) {
    const selectedColor = event.target.value;
    this.selectedColor = selectedColor;
    console.log(selectedColor);
  }

  setColor() {
    this.themeService.setPrimaryColor(this.selectedColor);
  }
}
